import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, useBreakpointValue } from "@gemini/core";
import { Modal } from "@gemini/ui";
import { useIsLandscape, useKeyboardNav } from "@/hooks";
import { ModalTopBar } from "@/components/UI";
import { useI18n } from "@/shared/hooks";
import { SocialAndPrintCTAs } from "@/shared/components/SocialAndPrintCTAs";
import { TAB_ITEMS } from "@/components/UI/Tabs/contants";
import { useGalleryContext } from "@/gallery/contexts";
import { useImages } from "@/gallery/hooks";
import { StickyCta } from "@/components/contacting";
import { useTrackingViewMedias } from "@/hooks/tracking/useTrackingViewMedias";
import { ThorView } from "@aviv-dxp/react-thor";
import { useFloorplans } from "@/components/Sections/Floorplan";
import { useGetThumbnailGalleryVariant } from "@/components/Sections/Location/hooks/useGetThumbnailGalleryVariant";
import { SwiperSlider, AdsExtraSlide, ContactExtraSlide, } from "@/shared/components/";
export const SliderModal = ({ isOpen, testId }) => {
    const { t } = useI18n();
    const { imagesFullscreen, imagesCount } = useImages();
    const { floorplansFullscreen } = useFloorplans();
    const isThumbnailGalleryActivated = useGetThumbnailGalleryVariant();
    const isLandscape = useIsLandscape();
    const [showControls, setShowControls] = useState(true);
    const { activeTab, isMasonryModalOpen, closeMasonryModal, toggleSliderModal, closeSliderModal, openMasonryAndReplace, galleryCount, currentStep, } = useGalleryContext();
    const isMobile = useBreakpointValue({
        base: true,
        md: false,
    });
    useEffect(() => {
        if (isOpen) {
            setShowControls(true);
        }
    }, [isOpen]);
    const backToMasonry = () => {
        closeSliderModal();
        if (activeTab === TAB_ITEMS.IMAGES && imagesCount > 3) {
            if (!isMasonryModalOpen && !isThumbnailGalleryActivated) {
                openMasonryAndReplace();
            }
        }
        // reset position to image tab if there are more than one image
        if (activeTab !== TAB_ITEMS.IMAGES && imagesCount > 1) {
            if (isMasonryModalOpen)
                closeMasonryModal();
        }
    };
    const handleScreenPress = () => {
        if (isMobile || isLandscape) {
            setShowControls((showControls) => !showControls);
        }
    };
    useKeyboardNav({
        handleEscape: isOpen ? backToMasonry : undefined,
    });
    const trackingViewData = useTrackingViewMedias(activeTab === "floorplans"
        ? "classified_detail_media_floorplan"
        : "classified_detail_media_fullscreen");
    if (galleryCount < 1)
        return null;
    return (_jsxs(Modal, { displayMode: "fullscreen", hasContentPadding: false, hasCloseButton: false, isOpen: isOpen, trigger: () => null, onOpenChange: toggleSliderModal, isKeyboardDismissDisabled: true, children: [_jsx(ThorView, { viewProps: trackingViewData }), _jsxs(Box, { height: "100%", backgroundColor: "color.background.constant.black", position: "relative", display: "flex", flexDirection: "column", overflow: "hidden", children: [_jsx(ModalTopBar, { testId: `${testId}.TopBar`, closeAction: backToMasonry, buttonLabel: t("gallery.modal.back.cta"), variant: "dark", additionalCTAs: _jsx(SocialAndPrintCTAs, { dark: true, variant: "tertiary-inverted" }), headline: _jsx(ABTestIndicator, { current: currentStep, total: galleryCount }), closeIcon: "close", showControls: showControls, showContacting: !isThumbnailGalleryActivated, tracking: {
                            avZone: "image_fullscreen",
                        }, showTabs: !isThumbnailGalleryActivated }), activeTab === "images" && (_jsx(SwiperSlider, { medias: imagesFullscreen, extraSlides: [ContactExtraSlide, AdsExtraSlide], onContainerPress: handleScreenPress, showControls: showControls, testId: `${testId}-images-slider` })), activeTab === "floorplans" && (_jsx(SwiperSlider, { medias: floorplansFullscreen, onContainerPress: handleScreenPress, showFloorplanSurvey: true, showControls: showControls, testId: `${testId}-floorplans-slider` })), showControls && !isThumbnailGalleryActivated && !isLandscape && (_jsx(StickyCta, { tracking: { avZone: "image_fullscreen" }, variant: "dark" }))] })] }));
};
// Should be replace by default Indicator after AB-test
const ABTestIndicator = ({ current, total }) => {
    const isThumbnailGalleryActivated = useGetThumbnailGalleryVariant();
    const showIndicator = current < total;
    if (!isThumbnailGalleryActivated || !showIndicator)
        return null;
    return _jsx(Box, { children: `${current + 1} / ${total}` });
};
